import React, { useState } from "react";
import "./../../css/HomeFinancialSolutions.css";
import { FaHandshake } from "react-icons/fa";
import { FaCircleCheck } from "react-icons/fa6";
import { FinanceImage } from "../../assets/images";

const TABS = ["Why Need Consultation?", "Why Choose Us", "How it works"];

const HomeFinancialSolutions = () => {
  const [activeTab, setActiveTab] = useState(TABS[0]);

  return (
    <section className='home-section'>
      <div className='home-left'>
        <div className='home-content'>
          <h2 className='custom-heading'>
            Smarter Air Solutions for Your Industry’s Future
          </h2>
          <a href='/services' className='explore-button'>
            Explore More
          </a>

          <div className='scroll-active'>
            <div className='tab-buttons'>
              {TABS.map((item) => (
                <button
                  onClick={() => setActiveTab(item)}
                  className={`tab-button ${
                    activeTab === item ? "active-tab" : ""
                  }`}
                  key={item}
                >
                  {item}
                </button>
              ))}
            </div>
          </div>

          <div className='none-scroll'>
            {TABS.map((item) => (
              <button
                onClick={() => setActiveTab(item)}
                className={`tab-button ${
                  activeTab === item ? "active-tab" : ""
                }`}
                key={item}
              >
                {item}
              </button>
            ))}
          </div>

          <div className='divider'></div>
          {activeTab === TABS[0] && <ConsultationTab />}
          {activeTab === TABS[1] &&<HowItWorksTab /> }
          {activeTab === TABS[2] && <ChooseUsTab />}
        </div>
      </div>

      <div className='home-image'>
        <img src={FinanceImage} alt='Finance' className='img-cover' />
      </div>
    </section>
  );
};

const HowItWorksTab = () => {
  return (
    <div className='tab-section'>
      <p className='text-gray'>
        In today’s industrial environment, ensuring efficient and compliant air
        pollution control requires a clear, expert-driven process.
      </p>
      <div className='how-grid'>
        {HOW_IT_WORKS.map((item, index) => (
          <div key={item.title}>
            <span className='step-title'>
              0{index + 1}. {item.title}
            </span>
            <p className='text-gray'>{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

const ChooseUsTab = () => {
  const items = [
    "Growth & Performance Analysis",
    "Quality-Driven Process Improvement",
    "Project Management Support",
    "Preventive Maintenance Expertise",
    "Assessment & Compliance Reporting",
    "Rapid Parts & Supply",
    "Tailored Technical Consultations",
    "Safety-Certified Technicians",
  ];

  return (
    <div className='tab-section'>
      <p className='text-gray'>
        Combining decades of hands-on experience with innovative solutions, we
        deliver exceptional value by ensuring efficient, compliant, and reliable
        air pollution control systems...
      </p>
      <ul className='choose-list'>
        {items.map((item) => (
          <li key={item} className='check-item'>
            <FaCircleCheck className='icon' color='#0076fe' />
            <span>{item}</span>
          </li>
        ))}
      </ul>
      <a href='/aboutus' className='about-button'>
        About Us
      </a>
    </div>
  );
};

const ConsultationTab = () => {
  const points = [
    "Investment with Integrity",
    "Visual Project Management",
    "Technical Expertise",
  ];

  return (
    <div className='tab-section'>
      <p className='text-gray'>
        In an industrial landscape driven by efficiency, safety, and compliance,
        reliable air pollution control is not optional—it’s essential. Yet, not
        every operation knows the best path forward. That’s where we come in.
      </p>
      <div className='commitment-grid'>
        <span>
          <FaHandshake className='commitment-icon' color='#0076fe' />
        </span>
        <span className='commitment-title'>Our Commitment</span>
        <div>
          <p className='text-gray'>
            With decades of hands-on experience, we’re committed to helping you
            operate smarter, safer, and cleaner...
          </p>
          <ul className='commitment-list'>
            {points.map((item) => (
              <li key={item} className='check-item'>
                <FaCircleCheck className='icon' color='#0076fe' />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

const HOW_IT_WORKS = [
  {
    title: "Consultation",
    description:
      "We engage with clients to understand their dust collection system needs, challenges, and operational goals.",
  },
  {
    title: "Evaluation",
    description:
      "Our experts conduct thorough system assessments, including airflow analysis, diagnostics, and compliance checks.",
  },
  {
    title: "Implementation & Support",
    description:
      "We develop tailored solutions—maintenance, repairs, or upgrades—and provide ongoing training and emergency response.",
  },
];

export default HomeFinancialSolutions;
